module.exports = __webpack_public_path__ + "img/titimg7.0edd567e.png";